import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/securityidentifier.proto" (package "proto.common", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/wrappers_pb";
/**
 * @generated from protobuf enum proto.common.SecurityIdentifier.Consolidated.Kind
 */

export var SecurityIdentifier_Consolidated_Kind;

(function (SecurityIdentifier_Consolidated_Kind) {
  /**
   * @generated from protobuf enum value: UNKNOWN = 0;
   */
  SecurityIdentifier_Consolidated_Kind[SecurityIdentifier_Consolidated_Kind["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * Консолидированный инструмент на американском рынке
   *
   * @generated from protobuf enum value: US_MARKET = 1;
   */

  SecurityIdentifier_Consolidated_Kind[SecurityIdentifier_Consolidated_Kind["US_MARKET"] = 1] = "US_MARKET";
  /**
   * Возвращается инструмент с максимальной датой обновления информации (В настоящий момент не реализовано)
   *
   * @generated from protobuf enum value: ISIN = 2;
   */

  SecurityIdentifier_Consolidated_Kind[SecurityIdentifier_Consolidated_Kind["ISIN"] = 2] = "ISIN";
})(SecurityIdentifier_Consolidated_Kind || (SecurityIdentifier_Consolidated_Kind = {})); // @generated message type with reflection information, may provide speed optimized methods


var SecurityIdentifier$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(SecurityIdentifier$Type, _MessageType);

  var _super = _createSuper(SecurityIdentifier$Type);

  function SecurityIdentifier$Type() {
    _classCallCheck(this, SecurityIdentifier$Type);

    return _super.call(this, "proto.common.SecurityIdentifier", [{
      no: 1,
      name: "security_id",
      kind: "scalar",
      oneof: "spec",
      T: 3
      /*ScalarType.INT64*/

    }, {
      no: 2,
      name: "ticker_mic",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_TickerAndMic;
      }
    }, {
      no: 3,
      name: "seccode_secboard",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_SeccodeAndSecboard;
      }
    }, {
      no: 4,
      name: "isin_mic",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_IsinAndMic;
      }
    }, {
      no: 5,
      name: "consolidated",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_Consolidated;
      }
    }, {
      no: 6,
      name: "bloomberg_symbol",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 7,
      name: "esignal_symbol",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 8,
      name: "ric",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 9,
      name: "sedol",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 10,
      name: "bbgid",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_BBGID;
      }
    }, {
      no: 11,
      name: "ticker_transaqmarket",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_TickerAndTransaqMarket;
      }
    }, {
      no: 12,
      name: "mma_code",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 13,
      name: "issuer",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_Issuer;
      }
    }, {
      no: 14,
      name: "ticker_transaqmarketnum",
      kind: "message",
      oneof: "spec",
      T: function T() {
        return SecurityIdentifier_TickerAndTransaqMarketNum;
      }
    }, {
      no: 15,
      name: "bloomberg_name",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 16,
      name: "mt5_symbol",
      kind: "scalar",
      oneof: "spec",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 100,
      name: "liquidity_pool_code",
      kind: "message",
      T: function T() {
        return StringValue;
      }
    }]);
  }

  _createClass(SecurityIdentifier$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        spec: {
          oneofKind: undefined
        }
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* int64 security_id */
          1:
            message.spec = {
              oneofKind: "securityId",
              securityId: reader.int64().toString()
            };
            break;

          case
          /* proto.common.SecurityIdentifier.TickerAndMic ticker_mic */
          2:
            message.spec = {
              oneofKind: "tickerMic",
              tickerMic: SecurityIdentifier_TickerAndMic.internalBinaryRead(reader, reader.uint32(), options, message.spec.tickerMic)
            };
            break;

          case
          /* proto.common.SecurityIdentifier.SeccodeAndSecboard seccode_secboard */
          3:
            message.spec = {
              oneofKind: "seccodeSecboard",
              seccodeSecboard: SecurityIdentifier_SeccodeAndSecboard.internalBinaryRead(reader, reader.uint32(), options, message.spec.seccodeSecboard)
            };
            break;

          case
          /* proto.common.SecurityIdentifier.IsinAndMic isin_mic */
          4:
            message.spec = {
              oneofKind: "isinMic",
              isinMic: SecurityIdentifier_IsinAndMic.internalBinaryRead(reader, reader.uint32(), options, message.spec.isinMic)
            };
            break;

          case
          /* proto.common.SecurityIdentifier.Consolidated consolidated */
          5:
            message.spec = {
              oneofKind: "consolidated",
              consolidated: SecurityIdentifier_Consolidated.internalBinaryRead(reader, reader.uint32(), options, message.spec.consolidated)
            };
            break;

          case
          /* string bloomberg_symbol */
          6:
            message.spec = {
              oneofKind: "bloombergSymbol",
              bloombergSymbol: reader.string()
            };
            break;

          case
          /* string esignal_symbol */
          7:
            message.spec = {
              oneofKind: "esignalSymbol",
              esignalSymbol: reader.string()
            };
            break;

          case
          /* string ric */
          8:
            message.spec = {
              oneofKind: "ric",
              ric: reader.string()
            };
            break;

          case
          /* string sedol */
          9:
            message.spec = {
              oneofKind: "sedol",
              sedol: reader.string()
            };
            break;

          case
          /* proto.common.SecurityIdentifier.BBGID bbgid */
          10:
            message.spec = {
              oneofKind: "bbgid",
              bbgid: SecurityIdentifier_BBGID.internalBinaryRead(reader, reader.uint32(), options, message.spec.bbgid)
            };
            break;

          case
          /* proto.common.SecurityIdentifier.TickerAndTransaqMarket ticker_transaqmarket */
          11:
            message.spec = {
              oneofKind: "tickerTransaqmarket",
              tickerTransaqmarket: SecurityIdentifier_TickerAndTransaqMarket.internalBinaryRead(reader, reader.uint32(), options, message.spec.tickerTransaqmarket)
            };
            break;

          case
          /* string mma_code = 12 [deprecated = true];*/
          12:
            message.spec = {
              oneofKind: "mmaCode",
              mmaCode: reader.string()
            };
            break;

          case
          /* proto.common.SecurityIdentifier.Issuer issuer */
          13:
            message.spec = {
              oneofKind: "issuer",
              issuer: SecurityIdentifier_Issuer.internalBinaryRead(reader, reader.uint32(), options, message.spec.issuer)
            };
            break;

          case
          /* proto.common.SecurityIdentifier.TickerAndTransaqMarketNum ticker_transaqmarketnum */
          14:
            message.spec = {
              oneofKind: "tickerTransaqmarketnum",
              tickerTransaqmarketnum: SecurityIdentifier_TickerAndTransaqMarketNum.internalBinaryRead(reader, reader.uint32(), options, message.spec.tickerTransaqmarketnum)
            };
            break;

          case
          /* string bloomberg_name */
          15:
            message.spec = {
              oneofKind: "bloombergName",
              bloombergName: reader.string()
            };
            break;

          case
          /* string mt5_symbol */
          16:
            message.spec = {
              oneofKind: "mt5Symbol",
              mt5Symbol: reader.string()
            };
            break;

          case
          /* google.protobuf.StringValue liquidity_pool_code */
          100:
            message.liquidityPoolCode = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.liquidityPoolCode);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int64 security_id = 1; */
      if (message.spec.oneofKind === "securityId") writer.tag(1, WireType.Varint).int64(message.spec.securityId);
      /* proto.common.SecurityIdentifier.TickerAndMic ticker_mic = 2; */

      if (message.spec.oneofKind === "tickerMic") SecurityIdentifier_TickerAndMic.internalBinaryWrite(message.spec.tickerMic, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.SecurityIdentifier.SeccodeAndSecboard seccode_secboard = 3; */

      if (message.spec.oneofKind === "seccodeSecboard") SecurityIdentifier_SeccodeAndSecboard.internalBinaryWrite(message.spec.seccodeSecboard, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.SecurityIdentifier.IsinAndMic isin_mic = 4; */

      if (message.spec.oneofKind === "isinMic") SecurityIdentifier_IsinAndMic.internalBinaryWrite(message.spec.isinMic, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.SecurityIdentifier.Consolidated consolidated = 5; */

      if (message.spec.oneofKind === "consolidated") SecurityIdentifier_Consolidated.internalBinaryWrite(message.spec.consolidated, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* string bloomberg_symbol = 6; */

      if (message.spec.oneofKind === "bloombergSymbol") writer.tag(6, WireType.LengthDelimited).string(message.spec.bloombergSymbol);
      /* string esignal_symbol = 7; */

      if (message.spec.oneofKind === "esignalSymbol") writer.tag(7, WireType.LengthDelimited).string(message.spec.esignalSymbol);
      /* string ric = 8; */

      if (message.spec.oneofKind === "ric") writer.tag(8, WireType.LengthDelimited).string(message.spec.ric);
      /* string sedol = 9; */

      if (message.spec.oneofKind === "sedol") writer.tag(9, WireType.LengthDelimited).string(message.spec.sedol);
      /* proto.common.SecurityIdentifier.BBGID bbgid = 10; */

      if (message.spec.oneofKind === "bbgid") SecurityIdentifier_BBGID.internalBinaryWrite(message.spec.bbgid, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.SecurityIdentifier.TickerAndTransaqMarket ticker_transaqmarket = 11; */

      if (message.spec.oneofKind === "tickerTransaqmarket") SecurityIdentifier_TickerAndTransaqMarket.internalBinaryWrite(message.spec.tickerTransaqmarket, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
      /* string mma_code = 12 [deprecated = true]; */

      if (message.spec.oneofKind === "mmaCode") writer.tag(12, WireType.LengthDelimited).string(message.spec.mmaCode);
      /* proto.common.SecurityIdentifier.Issuer issuer = 13; */

      if (message.spec.oneofKind === "issuer") SecurityIdentifier_Issuer.internalBinaryWrite(message.spec.issuer, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.SecurityIdentifier.TickerAndTransaqMarketNum ticker_transaqmarketnum = 14; */

      if (message.spec.oneofKind === "tickerTransaqmarketnum") SecurityIdentifier_TickerAndTransaqMarketNum.internalBinaryWrite(message.spec.tickerTransaqmarketnum, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
      /* string bloomberg_name = 15; */

      if (message.spec.oneofKind === "bloombergName") writer.tag(15, WireType.LengthDelimited).string(message.spec.bloombergName);
      /* string mt5_symbol = 16; */

      if (message.spec.oneofKind === "mt5Symbol") writer.tag(16, WireType.LengthDelimited).string(message.spec.mt5Symbol);
      /* google.protobuf.StringValue liquidity_pool_code = 100; */

      if (message.liquidityPoolCode) StringValue.internalBinaryWrite(message.liquidityPoolCode, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier
 */


export var SecurityIdentifier = new SecurityIdentifier$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_TickerAndMic$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(SecurityIdentifier_TickerAndMic$Type, _MessageType2);

  var _super2 = _createSuper(SecurityIdentifier_TickerAndMic$Type);

  function SecurityIdentifier_TickerAndMic$Type() {
    _classCallCheck(this, SecurityIdentifier_TickerAndMic$Type);

    return _super2.call(this, "proto.common.SecurityIdentifier.TickerAndMic", [{
      no: 1,
      name: "ticker",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "mic",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_TickerAndMic$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        ticker: "",
        mic: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* string ticker */
          1:
            message.ticker = reader.string();
            break;

          case
          /* string mic */
          2:
            message.mic = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string ticker = 1; */
      if (message.ticker !== "") writer.tag(1, WireType.LengthDelimited).string(message.ticker);
      /* string mic = 2; */

      if (message.mic !== "") writer.tag(2, WireType.LengthDelimited).string(message.mic);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_TickerAndMic$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.TickerAndMic
 */


export var SecurityIdentifier_TickerAndMic = new SecurityIdentifier_TickerAndMic$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_SeccodeAndSecboard$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(SecurityIdentifier_SeccodeAndSecboard$Type, _MessageType3);

  var _super3 = _createSuper(SecurityIdentifier_SeccodeAndSecboard$Type);

  function SecurityIdentifier_SeccodeAndSecboard$Type() {
    _classCallCheck(this, SecurityIdentifier_SeccodeAndSecboard$Type);

    return _super3.call(this, "proto.common.SecurityIdentifier.SeccodeAndSecboard", [{
      no: 1,
      name: "seccode",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "secboard",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_SeccodeAndSecboard$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        seccode: "",
        secboard: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* string seccode */
          1:
            message.seccode = reader.string();
            break;

          case
          /* string secboard */
          2:
            message.secboard = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string seccode = 1; */
      if (message.seccode !== "") writer.tag(1, WireType.LengthDelimited).string(message.seccode);
      /* string secboard = 2; */

      if (message.secboard !== "") writer.tag(2, WireType.LengthDelimited).string(message.secboard);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_SeccodeAndSecboard$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.SeccodeAndSecboard
 */


export var SecurityIdentifier_SeccodeAndSecboard = new SecurityIdentifier_SeccodeAndSecboard$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_IsinAndMic$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(SecurityIdentifier_IsinAndMic$Type, _MessageType4);

  var _super4 = _createSuper(SecurityIdentifier_IsinAndMic$Type);

  function SecurityIdentifier_IsinAndMic$Type() {
    _classCallCheck(this, SecurityIdentifier_IsinAndMic$Type);

    return _super4.call(this, "proto.common.SecurityIdentifier.IsinAndMic", [{
      no: 1,
      name: "isin",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "mic",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_IsinAndMic$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        isin: "",
        mic: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* string isin */
          1:
            message.isin = reader.string();
            break;

          case
          /* string mic */
          2:
            message.mic = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string isin = 1; */
      if (message.isin !== "") writer.tag(1, WireType.LengthDelimited).string(message.isin);
      /* string mic = 2; */

      if (message.mic !== "") writer.tag(2, WireType.LengthDelimited).string(message.mic);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_IsinAndMic$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.IsinAndMic
 */


export var SecurityIdentifier_IsinAndMic = new SecurityIdentifier_IsinAndMic$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_Consolidated$Type = /*#__PURE__*/function (_MessageType5) {
  _inherits(SecurityIdentifier_Consolidated$Type, _MessageType5);

  var _super5 = _createSuper(SecurityIdentifier_Consolidated$Type);

  function SecurityIdentifier_Consolidated$Type() {
    _classCallCheck(this, SecurityIdentifier_Consolidated$Type);

    return _super5.call(this, "proto.common.SecurityIdentifier.Consolidated", [{
      no: 1,
      name: "kind",
      kind: "enum",
      T: function T() {
        return ["proto.common.SecurityIdentifier.Consolidated.Kind", SecurityIdentifier_Consolidated_Kind];
      }
    }, {
      no: 2,
      name: "ticker",
      kind: "scalar",
      oneof: "idOneof",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "isin",
      kind: "scalar",
      oneof: "idOneof",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_Consolidated$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        kind: 0,
        idOneof: {
          oneofKind: undefined
        }
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* proto.common.SecurityIdentifier.Consolidated.Kind kind */
          1:
            message.kind = reader.int32();
            break;

          case
          /* string ticker */
          2:
            message.idOneof = {
              oneofKind: "ticker",
              ticker: reader.string()
            };
            break;

          case
          /* string isin */
          3:
            message.idOneof = {
              oneofKind: "isin",
              isin: reader.string()
            };
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.common.SecurityIdentifier.Consolidated.Kind kind = 1; */
      if (message.kind !== 0) writer.tag(1, WireType.Varint).int32(message.kind);
      /* string ticker = 2; */

      if (message.idOneof.oneofKind === "ticker") writer.tag(2, WireType.LengthDelimited).string(message.idOneof.ticker);
      /* string isin = 3; */

      if (message.idOneof.oneofKind === "isin") writer.tag(3, WireType.LengthDelimited).string(message.idOneof.isin);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_Consolidated$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.Consolidated
 */


export var SecurityIdentifier_Consolidated = new SecurityIdentifier_Consolidated$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_TickerAndTransaqMarket$Type = /*#__PURE__*/function (_MessageType6) {
  _inherits(SecurityIdentifier_TickerAndTransaqMarket$Type, _MessageType6);

  var _super6 = _createSuper(SecurityIdentifier_TickerAndTransaqMarket$Type);

  function SecurityIdentifier_TickerAndTransaqMarket$Type() {
    _classCallCheck(this, SecurityIdentifier_TickerAndTransaqMarket$Type);

    return _super6.call(this, "proto.common.SecurityIdentifier.TickerAndTransaqMarket", [{
      no: 1,
      name: "ticker",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "market",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }]);
  }

  _createClass(SecurityIdentifier_TickerAndTransaqMarket$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        ticker: "",
        market: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case
          /* string ticker */
          1:
            message.ticker = reader.string();
            break;

          case
          /* int32 market */
          2:
            message.market = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string ticker = 1; */
      if (message.ticker !== "") writer.tag(1, WireType.LengthDelimited).string(message.ticker);
      /* int32 market = 2; */

      if (message.market !== 0) writer.tag(2, WireType.Varint).int32(message.market);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_TickerAndTransaqMarket$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.TickerAndTransaqMarket
 */


export var SecurityIdentifier_TickerAndTransaqMarket = new SecurityIdentifier_TickerAndTransaqMarket$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_TickerAndTransaqMarketNum$Type = /*#__PURE__*/function (_MessageType7) {
  _inherits(SecurityIdentifier_TickerAndTransaqMarketNum$Type, _MessageType7);

  var _super7 = _createSuper(SecurityIdentifier_TickerAndTransaqMarketNum$Type);

  function SecurityIdentifier_TickerAndTransaqMarketNum$Type() {
    _classCallCheck(this, SecurityIdentifier_TickerAndTransaqMarketNum$Type);

    return _super7.call(this, "proto.common.SecurityIdentifier.TickerAndTransaqMarketNum", [{
      no: 1,
      name: "ticker",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "market_num",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }]);
  }

  _createClass(SecurityIdentifier_TickerAndTransaqMarketNum$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        ticker: "",
        marketNum: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* string ticker */
          1:
            message.ticker = reader.string();
            break;

          case
          /* int32 market_num */
          2:
            message.marketNum = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string ticker = 1; */
      if (message.ticker !== "") writer.tag(1, WireType.LengthDelimited).string(message.ticker);
      /* int32 market_num = 2; */

      if (message.marketNum !== 0) writer.tag(2, WireType.Varint).int32(message.marketNum);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_TickerAndTransaqMarketNum$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.TickerAndTransaqMarketNum
 */


export var SecurityIdentifier_TickerAndTransaqMarketNum = new SecurityIdentifier_TickerAndTransaqMarketNum$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_BBGID$Type = /*#__PURE__*/function (_MessageType8) {
  _inherits(SecurityIdentifier_BBGID$Type, _MessageType8);

  var _super8 = _createSuper(SecurityIdentifier_BBGID$Type);

  function SecurityIdentifier_BBGID$Type() {
    _classCallCheck(this, SecurityIdentifier_BBGID$Type);

    return _super8.call(this, "proto.common.SecurityIdentifier.BBGID", [{
      no: 1,
      name: "composite",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "local",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_BBGID$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        composite: "",
        local: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case
          /* string composite */
          1:
            message.composite = reader.string();
            break;

          case
          /* string local */
          2:
            message.local = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string composite = 1; */
      if (message.composite !== "") writer.tag(1, WireType.LengthDelimited).string(message.composite);
      /* string local = 2; */

      if (message.local !== "") writer.tag(2, WireType.LengthDelimited).string(message.local);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_BBGID$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.BBGID
 */


export var SecurityIdentifier_BBGID = new SecurityIdentifier_BBGID$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SecurityIdentifier_Issuer$Type = /*#__PURE__*/function (_MessageType9) {
  _inherits(SecurityIdentifier_Issuer$Type, _MessageType9);

  var _super9 = _createSuper(SecurityIdentifier_Issuer$Type);

  function SecurityIdentifier_Issuer$Type() {
    _classCallCheck(this, SecurityIdentifier_Issuer$Type);

    return _super9.call(this, "proto.common.SecurityIdentifier.Issuer", [{
      no: 1,
      name: "global_parent_company",
      kind: "scalar",
      oneof: "issuerOneof",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "global_company",
      kind: "scalar",
      oneof: "issuerOneof",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "isin",
      kind: "scalar",
      oneof: "issuerOneof",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "mma_code",
      kind: "scalar",
      oneof: "issuerOneof",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 5,
      name: "long_company_name",
      kind: "scalar",
      oneof: "issuerOneof",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SecurityIdentifier_Issuer$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        issuerOneof: {
          oneofKind: undefined
        }
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case
          /* string global_parent_company */
          1:
            message.issuerOneof = {
              oneofKind: "globalParentCompany",
              globalParentCompany: reader.string()
            };
            break;

          case
          /* string global_company */
          2:
            message.issuerOneof = {
              oneofKind: "globalCompany",
              globalCompany: reader.string()
            };
            break;

          case
          /* string isin */
          3:
            message.issuerOneof = {
              oneofKind: "isin",
              isin: reader.string()
            };
            break;

          case
          /* string mma_code = 4 [deprecated = true];*/
          4:
            message.issuerOneof = {
              oneofKind: "mmaCode",
              mmaCode: reader.string()
            };
            break;

          case
          /* string long_company_name */
          5:
            message.issuerOneof = {
              oneofKind: "longCompanyName",
              longCompanyName: reader.string()
            };
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string global_parent_company = 1; */
      if (message.issuerOneof.oneofKind === "globalParentCompany") writer.tag(1, WireType.LengthDelimited).string(message.issuerOneof.globalParentCompany);
      /* string global_company = 2; */

      if (message.issuerOneof.oneofKind === "globalCompany") writer.tag(2, WireType.LengthDelimited).string(message.issuerOneof.globalCompany);
      /* string isin = 3; */

      if (message.issuerOneof.oneofKind === "isin") writer.tag(3, WireType.LengthDelimited).string(message.issuerOneof.isin);
      /* string mma_code = 4 [deprecated = true]; */

      if (message.issuerOneof.oneofKind === "mmaCode") writer.tag(4, WireType.LengthDelimited).string(message.issuerOneof.mmaCode);
      /* string long_company_name = 5; */

      if (message.issuerOneof.oneofKind === "longCompanyName") writer.tag(5, WireType.LengthDelimited).string(message.issuerOneof.longCompanyName);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SecurityIdentifier_Issuer$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.SecurityIdentifier.Issuer
 */


export var SecurityIdentifier_Issuer = new SecurityIdentifier_Issuer$Type();